import { RDGrazing } from '@cibo/core'
import { TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { EventDetailEditor } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { GrazingEventEditor } from './GrazingEventEditor'

export const GrazingEditor = ({
  fieldModels,
  year,
  name = 'grazing',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => {
  const { t } = useTranslation('@cibo/landmanager/GrazingEditor')
  const GrazingEventTableHead = () => (
    <TableHead>
      <TableRow>
        <TableCell>
          <Typography>
            {t('startDate')}{' '}
            <Typography variant="caption" component="span">
              {t('(optional)')}
            </Typography>
          </Typography>
        </TableCell>
        <TableCell>
          <Typography>{t('species')}</Typography>
        </TableCell>
        <TableCell>
          <Typography>{t('headCount')}</Typography>
        </TableCell>
        <TableCell>
          <Typography>{t('daysGrazing')}</Typography>
        </TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  )
  return (
    <EventDetailEditor<RDGrazing['input']>
      traitId={traitId}
      fieldModels={fieldModels}
      year={year}
      name={name}
      requirement={requirement}
      filterInputs={filterInputs}
      EventTableHead={GrazingEventTableHead}
      EventComponent={GrazingEventEditor}
      translationContext="grazing"
      defaultEvent={{ species: '', headCount: 0, daysGrazing: 0, startDate: null }}
    />
  )
}
